export const AUTH_CONFIG = {
  domain: 'autodesk.auth0.com',
  clientId: '0kGvggVSiTC4yiWbqnQQb4J288HogEH1',
  callbackUrl: 'https://analytics.alanho.work/callback'
};
